import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("แก้ไข")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonProvinceSelector = _resolveComponent("CommonProvinceSelector")!
  const _component_CommonDistrictSelector = _resolveComponent("CommonDistrictSelector")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonButtonGroup = _resolveComponent("CommonButtonGroup")!
  const _component_CommonSwitch = _resolveComponent("CommonSwitch")!
  const _component_CommonRichTableWithAxios = _resolveComponent("CommonRichTableWithAxios")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AdvancePageColumn = _resolveComponent("AdvancePageColumn")!

  return (_openBlock(), _createBlock(_component_AdvancePageColumn, { class: "list" }, {
    default: _withCtx(() => [
      _createVNode(_component_Panel, null, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_CommonProvinceSelector, {
                      modelValue: _ctx.address.provinces,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.provinces) = $event)),
                      label: 'เลือกจังหวัด',
                      showLabel: true,
                      multiple: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_CommonDistrictSelector, {
                      modelValue: _ctx.address.districts,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address.districts) = $event)),
                      label: 'เลือกจังหวัด',
                      showLabel: true,
                      multiple: "",
                      provinceIds: _ctx.computedProvinceIds
                    }, null, 8, ["modelValue", "provinceIds"])
                  ]),
                  _createVNode(_component_CommonRichTableWithAxios, {
                    class: "mt-2",
                    query: _ctx.getVendors,
                    option: _ctx.vendorTableOption,
                    refetch: _ctx.refetchQuery,
                    onFetching: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refetchQuery = false))
                  }, {
                    "column-_primaryControls-content": _withCtx((row) => [
                      _createVNode(_component_CommonButtonGroup, { small: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CommonButton, {
                            level: "black-blend",
                            icon: "/img/icons/icon_fast.svg#svgView(viewBox(240,48,24,24))",
                            iconClass: "w-6 h-6",
                            onClick: ($event: any) => (_ctx.$router.push({ name: 'VendorEdit', params: { id: row.item.id } }))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    "column-_activeControls-content": _withCtx((row) => [
                      _createVNode(_component_CommonSwitch, {
                        modelValue: row.item.active,
                        "onUpdate:modelValue": ($event: any) => (_ctx.toggleActivateVendor({ id: row.item.id, active: !row.item.active }))
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["query", "option", "refetch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}